<template>
  <div class="SOP">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        标准作业程序(SOP)
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索SOP名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="c-m-l-10" @click="doNew()">
          新建SOP
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                beanName: 'SOP',
                title: '标准作业程序(SOP)'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields">
            <template slot="bizType">
              <el-table-column prop="bizType" label="业务类型" width="120px">
                <template slot-scope="scope">
                  {{
                    osg.codelabel(
                      'SOPBizType' + (scope.row.type == 0 ? '' : scope.row.type),
                      scope.row.bizType
                    )
                  }}
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="SOP" :visible.sync="openDetail" :close-on-click-modal="false" width="800px">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      >
        <template slot="region">
          <el-select
            v-model="formData.region"
            placeholder="请选择"
            class="addSOPItem-select"
            clearable
            filterable
            @change="getSOPItems"
          >
            <el-option
              v-for="(item, i) in options.regions"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="launchItemId">
          <el-select
            v-model="formData.launchItemId"
            placeholder="请选择"
            class="addSOPItem-select"
            clearable
            filterable
          >
            <template v-for="(item, i) in options.SOPItems">
              <el-option
                :key="i"
                v-if="
                  item.launch === 1 &&
                    !formData.SOPItems.find(sopItem => sopItem._id == item._id) &&
                    formData.type == item.type &&
                    formData.bizType == item.bizType
                "
                :label="item.label"
                :value="item.value"
              ></el-option>
            </template>
          </el-select>
        </template>
        <template slot="sopItemIds">
          <div class="addSOPItem">
            <el-select
              v-model="currentSOPItemId"
              placeholder="请选择要添加的节点"
              class="addSOPItem-select"
              clearable
              filterable
            >
              <template v-for="(item, i) in options.SOPItems">
                <!-- SOP节点同一code类型只能选择1个，已作为启动节点的不能添加为SOP节点 -->
                <el-option
                  :key="i"
                  v-if="
                    item.launch === 0 &&
                      !formData.SOPItems.find(sopItem => item.code == sopItem.code) &&
                      item._id != formData.launchItemId &&
                      formData.type == item.type &&
                      formData.bizType == item.bizType
                  "
                  :label="item.label"
                  :value="item.value"
                  @click.native="currentSOPItem = item"
                ></el-option>
              </template>
            </el-select>
            <el-button type="primary" plain @click="addSOPItem" class="addSOPItem-button">
              添加节点
            </el-button>
          </div>
          <el-form-item v-if="formData.SOPItems.length > 1">
            <el-tag type="success" size="medium">支持拖拽SOP节点调整执行顺序</el-tag>
          </el-form-item>
          <draggable v-model="formData.SOPItems">
            <transition-group>
              <el-form-item v-for="(SOPItem, index) in formData.SOPItems" :key="index">
                <div class="condition-card">
                  <el-card shadow="hover">
                    <div class="c-flex c-flex-between">
                      <span>{{ SOPItem.name }}</span>
                      <span>
                        {{
                          osg.codelabel(
                            'SOPItemCode' + (SOPItem.type == 0 ? '' : SOPItem.type),
                            SOPItem.code
                          )
                        }}
                      </span>
                    </div>
                  </el-card>
                  <div class="card-remove">
                    <i class="el-icon-remove" @click="removeSOPItem(index)"></i>
                  </div>
                </div>
              </el-form-item>
            </transition-group>
          </draggable>
        </template>
        <template slot="conditions">
          <el-form-item>
            <el-tag type="success" size="medium">多条件均满足时策略生效</el-tag>
          </el-form-item>
          <el-form-item v-for="(condition, index) of formData.conditions" :key="index">
            <div>条件{{ index + 1 }}</div>
            <div class="condition-card">
              <el-card shadow="hover">
                <el-form-item label="分单条件">
                  <el-select
                    v-model="formData.conditions[index].type"
                    placeholder="请选择"
                    @change="
                      formData.conditions[index].value = '';
                      getOptions(formData.conditions[index].type);
                    "
                    clearable
                  >
                    <el-option
                      v-for="(item, i) in options.allotType"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!--按省市区-->
                <el-form-item
                  v-if="formData.conditions[index].type == 'area'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                  prop="area"
                >
                  <el-cascader
                    :props="area.props"
                    :options="area.options"
                    v-model="formData.conditions[index].value"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按服务区域-->
                <el-form-item
                  v-else-if="formData.conditions[index].type == 'serviceTerritory'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-select
                    v-model="formData.conditions[index].value"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder="可搜索服务区域"
                    :remote-method="getST"
                    @change="$forceUpdate()"
                    clearable
                  >
                    <el-option
                      v-for="(item, i) in options.serviceTerritory"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!--按渗漏部位-->
                <el-form-item
                  v-else-if="formData.conditions[index].type == 'exts.leakagesite_copy'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.repairParts"
                    :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按信息渠道-->
                <el-form-item
                  v-else-if="formData.conditions[index].type == 'channel'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.channel"
                    :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按其他 档案字段-->
                <el-form-item
                  v-else
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-select v-model="formData.conditions[index].value" multiple clearable>
                    <el-option
                      v-for="(item, i) in options[formData.conditions[index].type]"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <div class="card-remove">
                <i class="el-icon-remove" @click="removeCondition(index)"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button plain icon="el-icon-plus" class="button_dashed" @click="newCondition">
              新增条件
            </el-button>
          </el-form-item>
        </template>
        <template slot="scopeType">
          <el-select
            v-model="formData.scopeType"
            placeholder="请选择"
            filterable
            clearable
            @change="
              formData.scopeIds = [];
              $forceUpdate();
            "
          >
            <el-option
              v-for="(item, i) in options.SOPScopeType"
              :key="i"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 预览图片 -->
    <el-dialog :modal="false" custom-class="dialog-img" :visible.sync="upload.dialogVisible">
      <img width="100%" :src="upload.dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'SOP',
  data() {
    window.$this = this;
    return {
      name: 'SOP',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        SOPItems: [],
        conditions: [{ type: 'serviceTerritory', value: [] }],
        itemCodes: [],
        scopeIds: [],
        exts: {}
      },
      rules: this.$util.rules,
      options: {
        codecfg_SOPItemCode: { codeId: 'SOPItemCode' },
        codecfg_SOPItemCode1: { codeId: 'SOPItemCode1' },
        codecfg_SOPItemCode2: { codeId: 'SOPItemCode2' },
        AllSOPItems: [],
        SOPItems: [],
        scripts: [],
        codecfg_regions: { codeId: 'regions' },
        codecfg_allotType: { codeId: 'ALLOTTYPE' },
        serviceTerritory: [],
        cascadeCode_repairParts: [],
        cascadeCode_channel: [],
        allScoreCalcRules: [],
        scoreCalcRules: [],
        codecfg_partsOne: { codeId: 'partsOne' },
        partsOne: [],
        condScripts: [],
        allSR: [],
        SR: [],
        orgs: []
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      querying: false,
      currentSOPItemId: '',
      currentSOPItem: {}
    };
  },
  mounted() {
    this.osg.getFields('SOP', () => {
      this.osg.getFpi();
      this.getData();
      this.getSOPItems('all');
      this.getScripts();
      this.getST();
      this.getOrgs();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/basic/sop/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        SOPItems: [],
        conditions: [{ type: 'serviceTerritory', value: [] }],
        itemCodes: [],
        scopeIds: [],
        exts: {}
      };
    },
    doSave() {
      // 处理节点id
      this.formData.sopItemIds = [];
      this.formData.SOPItems.map(SOPItem => {
        this.formData.sopItemIds.push(SOPItem._id);
      });
      if (this.osg.validate()) {
        // 校验条件值必填
        for (let i = 0; i < this.formData.conditions.length; i++) {
          let condition = this.formData.conditions[i];
          if (condition.value.length == 0) {
            this.osg.alert('条件的值不能为空！');
            return;
          }
        }
        delete this.formData.SOPItems;
        this.osg.ajax('/basic/sop/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      // 请求条件值选项
      for (let condition of row.conditions) {
        this.getOptions(condition.type);
      }
      // 处理SOP节点返显值
      row.SOPItems = [];
      for (let i = 0; i < row.sopItemIds.length; i++) {
        let sopItemId = row.sopItemIds[i];
        for (let j = 0; j < this.options.AllSOPItems.length; j++) {
          let SOPItem = this.options.AllSOPItems[j];
          if (sopItemId == SOPItem._id) {
            row.SOPItems.push(SOPItem);
            break;
          }
        }
      }
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doEnable(id) {
      this.osg.ajax('basic/sop/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/sop/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/sop/remove.do', { id }, () => {
          this.getData();
          this.osg.toast('删除成功！');
        });
      });
    },
    getSOPItems(type) {
      this.osg.ajax(
        '/basic/sopi/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:region|string#and': type == 'all' ? null : this.formData.region,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (type == 'all') {
            this.options.AllSOPItems = res.data;
            this.options.SOPItems = res.data;
          } else {
            this.options.SOPItems = res.data;
          }
        },
        { noload: true }
      );
    },
    getScripts() {
      this.osg.ajax(
        'groovyScript/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:type|string#and': '10'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.scripts = res.data;
        },
        { noload: true }
      );
    },
    /**
     * SOP节点
     */
    addSOPItem() {
      if (!this.currentSOPItemId) {
        this.osg.toast('请选择要添加的节点', 'warning');
      } else {
        this.formData.SOPItems.push(this.currentSOPItem);
        this.currentSOPItemId = '';
        this.currentSOPItem = {};
      }
    },
    removeSOPItem(index) {
      this.formData.SOPItems.splice(index, 1);
    },
    /**
     * 条件
     */
    //新增条件
    newCondition() {
      this.formData.conditions.push({
        type: 'serviceTerritory',
        value: ''
      });
    },
    //删除条件
    removeCondition(index) {
      if (this.formData.conditions[index].type == 'serviceType') {
        this.formData.conditions.splice(index, 1);
        this.getSR();
      } else {
        this.formData.conditions.splice(index, 1);
      }
    },
    //获取字典表
    getOptions(type) {
      if (type != 'area' && type != 'serviceTerritory' && type != 'channel') {
        this.options['codecfg_' + type] = {
          codeId: type.indexOf('exts.') != -1 ? type.split('.')[1] : type
        };
        this.osg.codeoption(() => {
          this.$forceUpdate();
        });
      }
    },
    //获取服务区域
    getST(query, type) {
      // 获取条件中已选中的服务类型，用来匹配对应服务类型的服务区域。
      let serviceType;
      let serviceTypeCondition = this.formData.conditions.filter(
        item => item.type == 'serviceType'
      );
      if (serviceTypeCondition.length > 0) {
        serviceType = serviceTypeCondition[0].value;
      }

      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'regex:name|string#or': query,
          'in:serviceType|array#and': serviceType && serviceType.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritory = res.data;
          // 当条件中的服务类型修改，将服务区域中不符合的值删除
          if (type == 'serviceTypeChange' && serviceType) {
            // 获取条件中服务区域的值
            let serviceTerritoryCondition = this.formData.conditions.filter(
              item => item.type == 'serviceTerritory'
            );
            // 获取条件中服务区域的值
            if (serviceTerritoryCondition.length > 0) {
              let serviceTerritory = serviceTerritoryCondition[0].value;
              // 服务区域不为空时
              if (serviceTerritory) {
                let sTValue = res.data.map(item => item.value);
                let newST = [];
                serviceTerritory.map(item => {
                  // 判断已选中值是否在选中服务类型返回的服务区域中
                  if (sTValue.indexOf(item) != -1) {
                    newST.push(item);
                  }
                });
                // 将服务区域中符合服务类型的值赋值回去
                serviceTerritoryCondition[0].value = newST;
              }
            }
          }
          this.$forceUpdate();
        }
      );
    },
    /**
     * 可用范围
     */
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          notFilterOrgId: '1'
        },
        res => {
          res.data.orgName = res.data.orgName || '全部组织';
          this.options.orgs = [res.data];
        },
        {
          noload: true
        }
      );
    }
  }
};
</script>
<style lang="scss">
.SOP {
  .addSOPItem {
    display: flex;
    margin-bottom: 18px;
    .addSOPItem-select {
      flex: 1;
      input {
        border-radius: 4px 0 0 4px;
        border-right: 0;
      }
    }
    .addSOPItem-button {
      border-radius: 0 4px 4px 0;
      height: 32px;
    }
  }
  .el-card__body {
    padding: 8px 16px;
    cursor: move;
  }
  .condition-card {
    display: flex;
    justify-content: space-between;
    .el-card {
      width: 90% !important;
    }
    .card-remove {
      width: 10%;
      text-align: center;
      color: #f2795b;
      cursor: pointer;
      font-size: 18px;
    }
  }
}
</style>
